
export const firebaseConfigure = {
  apiKey: "AIzaSyD9J8N7Awsi9_ROQYBltKWdQ70jA18KUhQ",
  authDomain: "fir-2cf0c.firebaseapp.com",
  projectId: "fir-2cf0c",
  storageBucket: "fir-2cf0c.appspot.com",
  messagingSenderId: "172212338488",
  appId: "1:172212338488:web:983cd486454c8821b20bcd"
};


